import type { Operation } from "./types";

export function checkOperation({
	operation,
	operations,
	disabled,
}: {
	operation: string | string[];
	operations: Operation[];
	disabled?: boolean;
}) {
	if (disabled) {
		return true;
	}

	const keys = operations.map((o) => o.key);

	const result = Array.isArray(operation)
		? operation.some((o) => keys.includes(o))
		: keys.includes(operation);

	if (
		!result &&
		import.meta.env.DEV &&
		import.meta.env.VITE_DEBUG_CHECKS === "true"
	) {
		console.warn(`Operation ${operation} check failed`);
		console.table(operations);
	}

	return result;
}
